export default "__VITE_ASSET__07e9e2fb__"